/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import React from 'react'
import {AnimatedLogoProps} from './types'
import {Wrapper, HiddenSVG, AnimatedSVG, MarkBackground, MarkForeground} from './styles'

// orange-yellow: #F96C2C - #F9D95D
// green-blue: #1FDA96 - #3FB3F2
// pink-orange: #E54074 - #F96C2C

/**
 *
 * The AnimatedLLogo component take a `color` prop and displays an animated gradient effect on hover.
 *
 */
const AnimatedLogo = ({size = 96, color = '#000000', sx: sxProp}: AnimatedLogoProps) => {
  return (
    <Wrapper data-testid="logo-var-anm">
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-dark-grayscale">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 0.49803921568627" />
              <feFuncG type="table" tableValues="0 0.49803921568627" />
              <feFuncB type="table" tableValues="0 0.49803921568627" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-grayscale">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-purple-yellow">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0.54901960784314 0.98823529411765" />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0.71764705882353 0.25490196078431" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-blue-red">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0 0.27843137254902" />
              <feFuncB type="table" tableValues="0.5921568627451 0.27843137254902" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-midnight">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 0" />
              <feFuncG type="table" tableValues="0 0.64705882352941" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-magenta-yellow">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0.78039215686275 1" />
              <feFuncG type="table" tableValues="0 0.94901960784314" />
              <feFuncB type="table" tableValues="0.35294117647059 0.47058823529412" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-purple-green">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0.65098039215686 0.40392156862745" />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0.44705882352941 0.4" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>
      <HiddenSVG viewBox="0 0 0 0" width="0" height="0" focusable="false" role="none">
        <defs>
          <filter id="mktng-duotone-blue-orange">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0.098039215686275 1" />
              <feFuncG type="table" tableValues="0 0.66274509803922" />
              <feFuncB type="table" tableValues="0.84705882352941 0.41960784313725" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </HiddenSVG>

      <AnimatedSVG x="0" y="0" width={size} height={size} viewBox="0 0 100 100">
        <g>
          <path
            fill="#fff"
            d="M185.6 25c-5.2-.1-10.3 1.7-14.2 5.1v-3.9l-9.5 4v60.3h9.5V70.1c2.9 2.4 6.3 4 10 4.6 15.9 2.5 28-9.5 28-24.7 0-13.8-10-25-23.8-25zM199 56c-1.3 4.5-5 7.9-9.5 9-10.3 2.3-17.7-4.9-18.1-14.3v-1.6c.4-8.1 6-14.6 14.2-14.6 10.5 0 16.8 10.5 13.4 21.5zM301.7 73.8h-9.5V30.2l9.5-4zM145.2 30.2c-4-3.4-9.1-5.3-14.3-5.2-16.6 0-27.7 16.1-22.6 33.6 2.5 8.5 9.8 14.8 18.6 16.1 7.4 1.1 13.7-.9 18.3-4.8v3.9h9.5V26.2l-9.5 4zm-.9 25.8c-1.3 4.5-5 7.9-9.5 9-10.6 2.4-18.1-5.3-18.1-15 0-8.5 5.8-15.5 14.3-15.5s14.2 6.8 14.3 15.2v.3c-.1 2.1-.4 4.1-1 6zM238.6 25c-5.2-.1-10.3 1.7-14.2 5.1v-3.9l-9.5 4v60.3h9.5V70.1c2.9 2.4 6.3 4 10 4.6 15.9 2.5 28-9.5 28-24.7 0-13.8-10-25-23.8-25zM252 56c-1.4 4.5-5 7.9-9.6 9-10.3 2.3-17.7-4.9-18.1-14.3v-1.6c.4-8.1 6-14.6 14.2-14.6 10.6 0 16.8 10.5 13.5 21.5zM326.7 25c-3.1 0-5.9 1.8-8.3 4.6v-3.4l-9.5 4v43.7h9.5V43.8c0-4.6 2.9-9.2 8.3-9.2 2.4-.1 4.7 1 6.2 2.9l4.4-8.8c-3-2.5-6.7-3.7-10.6-3.7zM368.9 63.5c-2.5 1.5-5.5 2-10.1 2-6.5.1-12.2-4.4-13.7-10.7h37.1c.3-1.6.4-3.2.4-4.8 0-13.8-10-25-23.8-25-14.6 0-24.9 12.5-23.7 27.3l.3 2.4c2 11.8 11.4 20.2 23.4 20.2 7.6 0 13.9-1.2 20-7.3l-9.9-4.1zm-10.1-29c6.9 0 11.9 4.5 13.6 10.7h-27.3c1.8-6.2 6.9-10.7 13.7-10.7z"
          />
          <path
            fill="#fff"
            d="M285.1 7.1c-9.2 0-16.7 7.5-16.7 16.7v6.4h-4.8v9.5h4.8v34h9.5v-34h9.5v-9.5h-9.5v-6.4c0-3.9 3.3-7.1 7.2-7.1 3.6 0 6.6 2.7 7 6.3l8.9-3.7c-1.9-7.2-8.5-12.1-15.9-12.2z"
          />
        </g>

        <mask id="Mark">
          <path
            fill="white"
            d="M99.4 92.5L81.7 57c-.6 4.8-2.2 9.3-4.9 13.3L84 84.7 43.1 67.6c-7.9-3.3-11.6-12.4-8.3-20.3.1-.3.3-.6.4-1L50 16.7l14.8 29.6c3.8 7.7.7 17-6.9 20.8-.3.2-.6.3-1 .4l-.2.1 11.5 4.8c8.7-7.8 11-20.4 5.8-30.8L54.6 2.9C53.3.3 50.2-.7 47.6.6c-1 .5-1.8 1.3-2.3 2.3L26 41.7C19.6 54.5 24.8 70 37.6 76.4c.5.3 1 .5 1.5.7l53.7 22.5c2.6 1.1 5.7-.1 6.8-2.8.6-1.4.5-2.9-.2-4.3z"
          />
          <path
            fill="white"
            d="M31 78.4l-15 6.2 7.2-14.3c-2.7-4-4.3-8.6-4.9-13.3L.6 92.5c-1.3 2.6-.3 5.7 2.3 6.9 1.4.7 2.9.7 4.3.1l36.1-15.1-6.2-2.6c-2.2-.8-4.2-2-6.1-3.4z"
          />
        </mask>

        <MarkBackground
          d="M78.6 62.6c4.4 2.3 3.9 7.9 3.9 7.9L94.7 95l-57-24.4s-15.6-10.2-6.9-28S50 4.5 50 4.5l20 40.7s9.2 17.9-13.4 28S5.7 95 5.7 95l11.1-24.2s1.6-7.5 3.9-8.5"
          fill="currentColor"
          stroke={color}
          strokeWidth="13"
          strokeMiterlimit="10"
          mask="url(#Mark)"
        />

        <MarkForeground
          d="M78.6 62.6c4.4 2.3 3.9 7.9 3.9 7.9L94.7 95l-57-24.4s-15.6-10.2-6.9-28S50 4.5 50 4.5l20 40.7s9.2 17.9-13.4 28S5.7 95 5.7 95l11.1-24.2s1.6-7.5 3.9-8.5"
          fill="none"
          stroke="#fff"
          strokeWidth="13"
          strokeMiterlimit="10"
          mask="url(#Mark)"
        />
      </AnimatedSVG>
    </Wrapper>
  )
}

export default AnimatedLogo
